import { Component, OnInit } from '@angular/core';
import { GoogleTagManagerService } from './services/utilities/google-tag-manager.service';
import { ToastrService } from 'ngx-toastr';
import { ThemeService } from './services/utilities/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    constructor(
        public toastr: ToastrService,
        private gtmService: GoogleTagManagerService,
        private themeService: ThemeService
    ) {
    }

    ngOnInit(): void {
        this.themeService.initTheme();
        this.gtmService.addGtmToDom();
    }
}
